/**
 * Gedeelde recency-logica voor keuzelijsten. Het venster is een parameter: de
 * ureninvoer heeft een weekritme (60 dagen), facturatie een maand-/kwartaalritme
 * (90 dagen).
 */

export function recencyRank(lastAt: string | null): number {
  return lastAt ? new Date(`${lastAt}T00:00:00`).getTime() : Number.NEGATIVE_INFINITY
}

export function isRecent(lastAt: string | null, windowDays: number): boolean {
  if (!lastAt) return false
  const days = (Date.now() - new Date(`${lastAt}T00:00:00`).getTime()) / 86_400_000
  return days <= windowDays
}

/** Sorteert recent-eerst, daarna alfabetisch op label. */
export function byRecency<T>(getLastAt: (item: T) => string | null, getLabel: (item: T) => string) {
  return (a: T, b: T): number =>
    recencyRank(getLastAt(b)) - recencyRank(getLastAt(a)) || getLabel(a).localeCompare(getLabel(b))
}

export function splitByRecency<T>(
  items: T[],
  getLastAt: (item: T) => string | null,
  windowDays: number,
): { recent: T[]; rest: T[] } {
  const recent = items.filter((item) => isRecent(getLastAt(item), windowDays))
  const rest = items.filter((item) => !isRecent(getLastAt(item), windowDays))
  return { recent, rest }
}
